import { Data } from "../../types/Data";
import { State } from "../../types/State";

export function getLabelTypeViager({
  state,
  data,
  defaultLabel,
}: {
  state: State;
  data: Data;
  defaultLabel: string;
}) {
  if (!state["type-viager"] || state["type-viager"].length === 0)
    return defaultLabel;
  return state["type-viager"]
    .map((value) => data["type-viager"][value].label)
    .join(", ");
}
